<template>
  <div class="container">
    <CollapsibleListItem icon="mdi-crown" :title="$t('MEMBER.PARENTS')" :expanded="false">
      <memlist-static-table
        id="member-table"
        style="width: 100%; table-layout: fixed;"
        class="table-striped"
        :fields="fields"
        :items="items"
        head-variant="light"
        ref="memberTable"
      >
        
      </memlist-static-table>
    </CollapsibleListItem>
    
  </div>

</template>


<script>

import axios from 'axios';
import dayjs from 'dayjs';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import { is_mobile } from '@/core/services/utils';
import CollapsibleListItem from './CollapsibleListItem.vue'

export default {

  name: 'MemberTableParents',

  props: ['member','items','company','expanded'],
  emits: ['save_data'],
  mixins: [ toasts ],

  components: {
    CollapsibleListItem
  },

  watch: {

  },

  computed: {
    is_mobile() {
      return is_mobile();
    },
  },

  methods: {

    async download_receipt(shop_order_id) {
      try {
        const res = await axios.get(`/shop_order/my_receipt/${shop_order_id}`);

        if (res.status === 200) {
          const file = res.data;
          downloadWithAxios(get_base_url() + `/dlfile/${file.linkstr}`, file.name);
          return;
        }
      }
      catch (err) {
        console.error(err);
      }

      this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('COMMON.UNABLE_DOWNLOAD'));
    },

    async save_data() {

      this.$emit('save_data', this.member);

    }

  },

  mounted() {
    this.show_form = this.expanded;

    if (this.is_mobile) {
      this.fields = this.fields.filter((field) => {
        return field.mobile;
      });
    }
  },

  data() {
    return {

      fields: [
        {
          key: 'firstname',
          label: this.$t('MEMBER.NAME'),
          mobile: true,
          sortable: false,
          tdClass: 'td-short2',
          thClass: 'td-short2',
          formatter: (_, __, item) => {
            return item.firstname + ' ' + item.lastname;
          }
        },

        {
          key: 'type',
          label: this.$t('PAYMENT.TYPE'),
          sortable: false,
          mobile: false,
          tdClass: 'td-short2',
          thClass: 'td-short2',

        },

        {
          key: 'phone',
          label: this.$t('MEMBER.PHONE'),
          sortable: false,
          tdClass: 'td-short2',
          thClass: 'td-short2'
        },

        {
          key: 'email',
          label: this.$t('MEMBER.EMAIL'),
          sortable: false,
          mobile: true,
          tdClass: 'td-short2',
          thClass: 'td-short2'
        }

      ],

      show_form: true,

    };
  }
};

</script>

<style lang="scss" scoped>
  
  
</style>
